import React, { useEffect, useMemo, useState } from "react";
import { FootBar } from "../components/Footer";
import { useParams } from "react-router";
import { UserApi } from "../app/api/user.api";


export function Validation()
{
    const user = useMemo(() => UserApi(), []);
    const { token } = useParams();

    const [isLoading, setIsLoading] = useState(true);
    const [status, setStatus] = useState(0);

    useEffect(() => {
      const activate = async () => {
        try {
          const { data } = await user.activateAccount({ code: token });
          setStatus(data.success ? 1 : -1);
        } catch (err) {
          setStatus(-1);
        } finally {
          setIsLoading(false);
        }
      };

      activate();
    }, [token, user]);

    
    return(

        <div className="container-fluid">
            
            <div className="row bg-light">
                <div className="col-lg-12"> 
                    {
                        isLoading && ( 
                        <div className="row d-flex flex-column align-items-center justify-content-center vh-100">
                            <div className="d-flex justify-content-center align-items-center mb-3"> 
                                <div className="spinner-border text-success" role="status" aria-label="Chargement"></div>
                            </div>
                        </div> 
                        )
                    }
                    {
                        (status === 1) && (

                        <div className="row d-flex flex-column align-items-center justify-content-center vh-100">
                            <div className="col-lg-5 col-md-8 d-flex justify-content-center">
                                <div className="d-flex mb-3" >
                                    <span className="d-flex align-items-center justify-content-center border px-4 py-2 rounded-2 bg-white">
                                        <img src={'../favicon.png'} className="" alt="Logement extérieur" style={{ width: "60px" }} />
                                     </span>
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-8 bg-white shadow-sm"> 
                                <div className="row d-flex flex-column justify-content-center rounded-2">
                                    <div className="d-flex align-items-center justify-content-center py-3 border-bottom rounded-3">
                                        <span className="lead text-secondary text-center" > <i className="bi bi-check me-3 text-success"></i> Compte activé avec succès </span>
                                    </div>
                                    <div className="d-flex flex-column p-4 border-bottom">
                                        <span className="text-secondary lead my-2 text-center"> Felicitation votre compte d'utilisateur est bien activé. Vous pouvez dorénavant vous connecter sur la plateforme et sur tout autre système lié à elle. </span> 
                                    </div>
                                    <div className="px-4 text-center"> <a href='/connexion' className='link btn btn-green-outline px-4 my-3'> Se connecter <i className="bi bi-arrow-right ms-3"></i>  </a> </div>
                                </div>
                            </div>
                        </div>

                        )
                    }
                    {
                        (status === -1) && (

                        <div className="row d-flex flex-column align-items-center justify-content-center vh-100">
                            <div className="col-lg-5 col-md-8 d-flex justify-content-center">
                                <div className="d-flex mb-3" >
                                    <span className="d-flex align-items-center justify-content-center border px-4 py-2 rounded-2 bg-white">
                                        <img src={'../favicon.png'} className="" alt="Logement extérieur" style={{ width: "60px" }} />
                                     </span>
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-8 bg-white shadow-sm"> 
                                <div className="row d-flex flex-column justify-content-center rounded-2">
                                    <div className="d-flex align-items-center justify-content-center py-3 border-bottom rounded-3">
                                        <span className="lead text-secondary text-center" > <i className="bi bi-check me-3 text-danger"></i> Erreur d'identification </span>
                                    </div>
                                    <div className="d-flex flex-column p-4 border-bottom">
                                        <span className="text-secondary lead my-2 text-center"> Vueillez réessayer à nouveau en cliquant sur le bouton. votre compte d'utilisateur est bien activé. Vous pouvez dorénavant vous connecter sur la plateforme et sur tout autre système lié à elle. </span> 
                                    </div>
                                </div>
                            </div>
                        </div>

                        )
                    }   
                </div>

                {/* ************************************************* */}
                <div className="col-lg-12 bg-dark">  <FootBar />  </div>

            </div>
        </div>
    )
}

